import React from 'react';

import moment from 'moment';

import Loading from 'components/layout/loading';
import { getRangeDateRefuel } from 'utils/getRangeDateRefuel';
import { useMediaQuery } from 'react-responsive';
import { getStatusType } from 'newComponents/NewNotifications/NotificationItem/util';
import TimeLIne from './TimeLIne';

import fuelGray from '../../../../assets/icons/fuelGray.svg';
import handsGray from '../../../../assets/icons/handsGray.svg';
import scheduleGray from '../../../../assets/icons/scheduleGray.svg';
import ully from '../../../../assets/icons/ully.svg';
import chat from '../../../../assets/icons/chat.svg';
import pine from '../../../../assets/icons/pine.svg';
import driverIcon from '../../../../assets/icons/driverIcon.svg';

import ChipStatus from './ChipStatus';
import { statusItems } from './ChipStatus/chipStatusItems';

import { useTrackingRefuel } from '../../../../hooks/useTrackingRefuel';

import {
  Container,
  HeaderWrapper,
  OrderNumberWrapper,
  LabelOrder,
  LabelNumber,
  LabelProcess,
  CloseButton,
  HeaderTextWrapper,
  OrderDateWrapper,
  LabelDate,
  LabelDateInfo,
  ContainerStatus,
  ContainerStatusHeader,
  StatusTitleWrapper,
  StatusIcon,
  StatusText,
  ProtocolWrapper,
  ProtocolLabel,
  ProtocolNumber,
  CloseIcon,
  StatusContentWrapper,
  ContainerDataWrapper,
  ContainerTracking,
  ContainerRefuelData,
  ContainerTrackingWrapper,
  ContainerRefuelDataWrapper,
  UllyWrapperContainer,
  ResumeTitle,
  ResumeItemsWrapper,
  ResumeItem,
  ResumeItemIconWrapper,
  ResumeItemInfosWrapper,
  ResumeItemTitle,
  ResumeItemInfo,
  ResumeItemIcon,
  UllyTitle,
  UllyContainerWrapper,
  UllyImage,
  UllyIcon,
  UllyTextWrapper,
  UllyInfosWrapper,
  UllyLabel,
  UllyText,
  IconClick,
  IconChat,
  TrackingInfosContainer,
  TrackingInfoTitleWrapper,
  TrackingInfoTitle,
  TrackingInfoSubtitle,
  TrackingTimeLineWrapper,
} from './styles';

type ModaldetailsProps = {
  dataDetail: any;
  closeModal: () => void;
  isLoading: boolean;
};

const ModalDetails: React.FC<ModaldetailsProps> = ({
  dataDetail,
  closeModal,
  isLoading,
}) => {
  const { getStatusTypeNumber, orderStatus, addressBase } = useTrackingRefuel();

  const isMobile = useMediaQuery({ maxWidth: 768 });

  const handleClickOpenChat = (): void => {
    const chatbotButton = document?.querySelector(
      '#hi-custom-widget'
    ) as HTMLElement;
    if (chatbotButton) {
      closeModal();
      chatbotButton?.click();
    }
  };

  const { statusNumber, description } = getStatusTypeNumber(
    dataDetail?.status?.code
  );

  const statusResponse = getStatusType(
    dataDetail?.status?.code,
    'refuel',
    true
  );

  const getRangeDateRefuelResponse = getRangeDateRefuel(
    dataDetail.forecastDate,
    dataDetail?.beginDate ?? null,
    dataDetail?.endDate ?? null,
    dataDetail?.suggestedDate ?? null,
    dataDetail?.agreedDate ?? null,
    dataDetail?.reprogrammingDate ?? null,
    dataDetail?.deliveryDate ?? null,
    // @ts-ignore
    statusResponse ?? null
  );

  const dateDelivery =
    statusResponse === 'Atendido'
      ? moment(dataDetail?.deliveryDate).format('DD/MM/YY')
      : '';

  return (
    <>
      {isLoading && <Loading />}
      <Container>
        {!isLoading && (
          <HeaderWrapper>
            <HeaderTextWrapper>
              {dataDetail?.orderNumber ? (
                <OrderNumberWrapper>
                  <LabelOrder>Pedido Nº</LabelOrder>
                  <LabelNumber>{dataDetail?.orderNumber}</LabelNumber>
                </OrderNumberWrapper>
              ) : (
                <OrderNumberWrapper>
                  <LabelOrder>Pedido</LabelOrder>
                  <LabelProcess>Em processamento</LabelProcess>
                </OrderNumberWrapper>
              )}
              <OrderDateWrapper>
                <LabelDate>Data do pedido:</LabelDate>
                <LabelDateInfo>
                  {moment(dataDetail?.createdDate).format('DD/MM/YYYY')}
                </LabelDateInfo>
              </OrderDateWrapper>
            </HeaderTextWrapper>
            <CloseButton>
              <CloseIcon
                onClick={closeModal}
                title="Fechar"
                className="mdi mdi-close"
              />
            </CloseButton>
          </HeaderWrapper>
        )}
        <ContainerStatus>
          <ContainerStatusHeader>
            <StatusTitleWrapper>
              <StatusIcon />
              <StatusText>{description}</StatusText>
            </StatusTitleWrapper>
            {!isMobile && dataDetail?.caseNumber && (
              <ProtocolWrapper>
                <ProtocolLabel>Nº do protocolo</ProtocolLabel>
                <ProtocolNumber>{dataDetail?.caseNumber}</ProtocolNumber>
              </ProtocolWrapper>
            )}
          </ContainerStatusHeader>
          <StatusContentWrapper>
            {statusItems.map((item) => (
              <ChipStatus
                key={item.id}
                item={item}
                active={
                  item.id < statusNumber ||
                  (item.id === Math.floor(statusNumber) && statusNumber >= 6)
                }
                selected={item.id === Math.floor(statusNumber) && item.id < 6}
                itemId={item.id}
                statusNumber={statusNumber}
              />
            ))}
          </StatusContentWrapper>
        </ContainerStatus>
        <ContainerDataWrapper>
          <ContainerTracking>
            <ContainerTrackingWrapper>
              <TrackingInfosContainer>
                <TrackingInfoTitleWrapper>
                  <TrackingInfoTitle>Acompanhe seu pedido</TrackingInfoTitle>
                  <TrackingInfoSubtitle>
                    Tenha uma visão detalhada do seu pedido.
                  </TrackingInfoSubtitle>
                </TrackingInfoTitleWrapper>
                <TrackingTimeLineWrapper>
                  <TimeLIne />
                </TrackingTimeLineWrapper>
              </TrackingInfosContainer>
            </ContainerTrackingWrapper>
          </ContainerTracking>
          <ContainerRefuelData>
            <ContainerRefuelDataWrapper>
              <ResumeTitle>Resumo do pedido</ResumeTitle>
              <ResumeItemsWrapper>
                {addressBase?.address && (
                  <ResumeItem>
                    <ResumeItemIconWrapper>
                      <ResumeItemIcon src={pine} />
                    </ResumeItemIconWrapper>
                    <ResumeItemInfosWrapper>
                      <ResumeItemTitle>Endereço de entrega</ResumeItemTitle>
                      <ResumeItemInfo>{addressBase?.baseName}</ResumeItemInfo>
                      <ResumeItemInfo>
                        {`${addressBase?.address}${
                          addressBase?.number ? `, ${addressBase?.number}` : ''
                        }${
                          addressBase?.complement
                            ? `- ${addressBase?.complement}`
                            : ''
                        }`}
                      </ResumeItemInfo>
                    </ResumeItemInfosWrapper>
                  </ResumeItem>
                )}
                {dataDetail?.currentGasPercentage && (
                  <ResumeItem>
                    <ResumeItemIconWrapper>
                      <ResumeItemIcon src={fuelGray} />
                    </ResumeItemIconWrapper>
                    <ResumeItemInfosWrapper>
                      <ResumeItemTitle>Nível atual do gás (%)</ResumeItemTitle>
                      <ResumeItemInfo>{`${dataDetail?.currentGasPercentage}% do gás`}</ResumeItemInfo>
                    </ResumeItemInfosWrapper>
                  </ResumeItem>
                )}
                {dataDetail?.contactName && (
                  <ResumeItem>
                    <ResumeItemIconWrapper>
                      <ResumeItemIcon src={handsGray} />
                    </ResumeItemIconWrapper>
                    <ResumeItemInfosWrapper>
                      <ResumeItemTitle>
                        Responsável pelo recebimento
                      </ResumeItemTitle>
                      <ResumeItemInfo>{dataDetail?.contactName}</ResumeItemInfo>
                    </ResumeItemInfosWrapper>
                  </ResumeItem>
                )}
                {getRangeDateRefuelResponse && (
                  <ResumeItem>
                    <ResumeItemIconWrapper>
                      <ResumeItemIcon src={scheduleGray} />
                    </ResumeItemIconWrapper>
                    <ResumeItemInfosWrapper>
                      <ResumeItemTitle>Previsão de entrega</ResumeItemTitle>
                      <ResumeItemInfo>
                        {getRangeDateRefuelResponse}
                      </ResumeItemInfo>
                    </ResumeItemInfosWrapper>
                  </ResumeItem>
                )}
                {dateDelivery && (
                  <ResumeItem>
                    <ResumeItemIconWrapper>
                      <ResumeItemIcon src={scheduleGray} />
                    </ResumeItemIconWrapper>
                    <ResumeItemInfosWrapper>
                      <ResumeItemTitle>Data de entrega</ResumeItemTitle>
                      <ResumeItemInfo>{dateDelivery}</ResumeItemInfo>
                    </ResumeItemInfosWrapper>
                  </ResumeItem>
                )}
                {dataDetail?.driverName && (
                  <ResumeItem>
                    <ResumeItemIconWrapper>
                      <ResumeItemIcon src={driverIcon} />
                    </ResumeItemIconWrapper>
                    <ResumeItemInfosWrapper>
                      <ResumeItemTitle>Entregador</ResumeItemTitle>
                      <ResumeItemInfo>{dataDetail?.driverName}</ResumeItemInfo>
                    </ResumeItemInfosWrapper>
                  </ResumeItem>
                )}
              </ResumeItemsWrapper>
            </ContainerRefuelDataWrapper>
            <UllyWrapperContainer>
              <UllyTitle>Precisa de ajuda ou tem alguma dúvida?</UllyTitle>
              <UllyContainerWrapper>
                <UllyImage>
                  <UllyIcon src={ully} />
                </UllyImage>
                <UllyTextWrapper>
                  <UllyInfosWrapper>
                    <UllyLabel>Fale com a</UllyLabel>
                    <UllyText onClick={() => handleClickOpenChat()}>
                      Ully.
                    </UllyText>
                  </UllyInfosWrapper>
                  <IconClick onClick={() => handleClickOpenChat()}>
                    <IconChat src={chat} />
                  </IconClick>
                </UllyTextWrapper>
              </UllyContainerWrapper>
            </UllyWrapperContainer>
          </ContainerRefuelData>
        </ContainerDataWrapper>
      </Container>
    </>
  );
};

export default ModalDetails;
